// Mirrors CommonApplicationEligibility in the Rails app (REASONS,
// CHECKING_STATUSES, SAVINGS_PRODUCT_STATUSES). These codes are a public API
// contract; the client owns the copy for each.

export enum CommonApplicationEligibilityReason {
  ACCOUNT_NOT_APPROVED = 'account_not_approved',
  ACCOUNT_HELD = 'account_held',
  CHECKING_PROCESSING = 'checking_processing',
  CHECKING_REQUIRED = 'checking_required',
  NO_PRODUCTS_AVAILABLE = 'no_products_available',
}

export enum CheckingStatus {
  READY = 'ready',
  REQUESTED = 'requested',
  PROCESSING = 'processing',
  NONE = 'none',
}

export enum SavingsProductStatus {
  AVAILABLE = 'available',
  PROCESSING = 'processing',
  OPEN = 'open',
}

export type CommonApplicationEligibility = {
  canApply: boolean;
  reason: CommonApplicationEligibilityReason | null;
  checking: {
    status: CheckingStatus;
    productUuid: string | null;
    productName: string | null;
    canChange: boolean;
  };
  savingsProducts: { uuid: string; status: SavingsProductStatus }[];
  draft: {
    uuid: string;
    hasProductSelections: boolean;
    startedByAdvisor: boolean;
    advisorName: string;
  } | null;
};
